import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore} from "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyDa0Qwi1RXvuyEL7di-yzwB-8ZI3VPeskc",
    authDomain: "compito-57c04.firebaseapp.com",
    projectId: "compito-57c04",
    storageBucket: "compito-57c04.appspot.com",
    messagingSenderId: "879927612251",
    appId: "1:879927612251:web:239e3596187fdaff95007e",
    measurementId: "G-KV2NJJMKGJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app)
